<script setup lang="ts">
import { $t } from '@/composables/translations/useTranslate';

interface Props {
  hotelImageUrl?: string;
  hotelName?: string;
  dateRange?: string;
  paxLabel?: string;
}

defineProps<Props>();

const emit = defineEmits<{
  expand: [];
}>();
</script>

<template>
  <div class="flex gap-4 p-4 bg-white rounded-[10px]">
    <img
      v-if="hotelImageUrl"
      :src="hotelImageUrl"
      :alt="hotelName || 'Hotel'"
      class="w-20 h-20 rounded-[10px] object-cover shrink-0"
      loading="lazy"
    />
    <div
      v-else
      class="w-20 h-20 rounded-[10px] bg-actions-tertiary animate-pulse shrink-0"
      aria-hidden="true"
    ></div>

    <div class="flex flex-col gap-[5px] min-w-0">
      <p v-if="hotelName" class="!font-medium text-text-primary text-body">{{ hotelName }}</p>
      <p v-if="dateRange" class="!font-semibold text-body-small">{{ dateRange }}</p>
      <p v-if="paxLabel" class="text-body-small">{{ paxLabel }}</p>

      <button
        type="button"
        class="mt-[5px] !font-medium text-left underline text-body-small"
        @click="emit('expand')"
      >
        {{ $t('ibe.checkout.order-summary.show-all-details', 'Alle Details anzeigen') }}
      </button>
    </div>
  </div>
</template>
